export default function ClarksvilleTravelTimingSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">When to Apply</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Best Times to Apply in Clarksville
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Timing your application around Fort Campbell deployment cycles and APSU academic calendars can save you weeks of processing time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-[#F7F8FA] rounded-xl p-8 border-l-4 border-[#F6C344]">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F6C344]/15">
                <i className="ri-shield-star-line text-[#1A365D] text-lg"></i>
              </div>
              <h3 className="font-serif text-lg font-bold text-[#1A365D]">Pre-Deployment</h3>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Apply at least 8-10 weeks before deployment cycles. The 101st Airborne typically rotates on predictable schedules — we coordinate with military families to ensure passports are ready before orders drop.
            </p>
            <div className="text-[#F6C344] text-sm font-semibold">
              <i className="ri-time-line mr-1"></i>
              Recommended: 8+ weeks advance
            </div>
          </div>

          <div className="bg-[#F7F8FA] rounded-xl p-8 border-l-4 border-[#1A365D]">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-graduation-cap-line text-[#1A365D] text-lg"></i>
              </div>
              <h3 className="font-serif text-lg font-bold text-[#1A365D]">Semester Breaks</h3>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              APSU students should apply during winter break (December-January) or summer break (May-June) for fall or spring semester study abroad programs. Avoid the August rush before fall departures.
            </p>
            <div className="text-[#1A365D] text-sm font-semibold">
              <i className="ri-time-line mr-1"></i>
              Recommended: 3-6 months before travel
            </div>
          </div>

          <div className="bg-[#F7F8FA] rounded-xl p-8 border-l-4 border-[#F6C344]">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F6C344]/15">
                <i className="ri-flight-takeoff-line text-[#1A365D] text-lg"></i>
              </div>
              <h3 className="font-serif text-lg font-bold text-[#1A365D]">R&R Leave Seasons</h3>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Many Fort Campbell soldiers take R&R during spring and summer. If you're planning family reunions abroad, apply 6-8 weeks before typical leave windows to avoid the seasonal passport rush.
            </p>
            <div className="text-[#F6C344] text-sm font-semibold">
              <i className="ri-time-line mr-1"></i>
              Recommended: 6-8 weeks before leave
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}